import { i18next } from "@translations/up/i18next";
import React from "react";
import PropTypes from "prop-types";
import { FieldLabel, Input, SelectField } from "react-invenio-forms";
import { Divider, Grid } from "semantic-ui-react";
import { DegreeNameField } from "./DegreeNameField";
import { UniversityField } from "./UniversityField";

export const ThesisField = ({
  fieldPath,
  record,
  options,
  label,
  icon,
  university,
  degree_name: degreeName,
  type,
  department,
  date_submitted: dateSubmitted,
  date_defended: dateDefended,
}) => {
  return (
    <>
      <FieldLabel htmlFor={fieldPath} icon={icon} label={label} />
      <Divider fitted />

      <Grid padded>
        <Grid.Column width="8">
          <UniversityField fieldPath={`${fieldPath}.university`} record={record} />
          {university.description && (
            <label className="helptext mb-0">{university.description}</label>
          )}
        </Grid.Column>

        <Grid.Column width="8">
          <DegreeNameField
            fieldPath={`${fieldPath}.degree_name`}
            label={degreeName.label}
            placeholder={degreeName.placeholder}
            record={record}
          />
          {degreeName.description && (
            <label className="helptext mb-0">{degreeName.description}</label>
          )}
        </Grid.Column>

        <Grid.Column width="8">
          <SelectField
            fieldPath={`${fieldPath}.type`}
            label={type.label}
            optimized
            options={options}
            required
          />
          {type.description && (
            <label className="helptext mb-0">{type.description}</label>
          )}
        </Grid.Column>

        <Grid.Column width="8">
          <Input
            fieldPath={`${fieldPath}.department`}
            label={department.label}
            placeholder={department.placeholder}
          />
          {department.description && (
            <label className="helptext mb-0">{department.description}</label>
          )}
        </Grid.Column>

        <Grid.Column width="8">
          <Input
            fieldPath={`${fieldPath}.date_submitted`}
            label={dateSubmitted.label}
            placeholder={dateSubmitted.placeholder}
          />
          {dateSubmitted.description && (
            <label className="helptext mb-0">{dateSubmitted.description}</label>
          )}
        </Grid.Column>
        <Grid.Column width="8">
          <Input
            fieldPath={`${fieldPath}.date_defended`}
            label={dateDefended.label}
            placeholder={dateDefended.placeholder}
          />
          {dateDefended.description && (
            <label className="helptext mb-0">{dateDefended.description}</label>
          )}
        </Grid.Column>
      </Grid>
    </>
  );
};

ThesisField.propTypes = {
  fieldPath: PropTypes.string.isRequired,
  record: PropTypes.object.isRequired,
  options: PropTypes.array,
  label: PropTypes.string,
  icon: PropTypes.string,
  university: PropTypes.shape({
    label: PropTypes.string,
    placeholder: PropTypes.string,
    description: PropTypes.string,
  }),
  degree_name: PropTypes.shape({
    label: PropTypes.string,
    placeholder: PropTypes.string,
    description: PropTypes.string,
  }),
  type: PropTypes.shape({
    label: PropTypes.string,
    placeholder: PropTypes.string,
    description: PropTypes.string,
  }),
  department: PropTypes.shape({
    label: PropTypes.string,
    placeholder: PropTypes.string,
    description: PropTypes.string,
  }),
  date_submitted: PropTypes.object.isRequired,
  date_defended: PropTypes.object.isRequired,
};

ThesisField.defaultProps = {
  label: i18next.t("Thesis"),
  icon: "university",
  options: [],
  university: {
    label: i18next.t("Awarding university"),
    placeholder: "",
    description: "",
  },
  degree_name: {
    label: i18next.t("Degree name"),
    placeholder: "",
    description: "",
  },
  type: {
    label: i18next.t("Thesis type"),
    placeholder: "",
    description: "",
  },
  department: {
    label: i18next.t("Program"),
    placeholder: "",
    description: "",
  },
};
